import './BannerImage.scss';
import Paragraph from 'components/TextComps/Paragraph';
import { useEffect, useState } from 'react';
import Subtitle from 'components/TextComps/Subtitle';
import { EditFileButton } from 'components/Admin/EditFileButton/EditFileButton';
import { FileManagerModal } from 'components/Admin/Modals/FileManagerModal/FileManagerModal';
import { FileNode } from '../../../../types/admin/nodes';
import { AdminImageType } from 'types/admin/media';

type Props = {
  image: AdminImageType | undefined;
  disabled: boolean;
  handleSelectedImage: (imageId: string) => void;
  imageVariant?: 'square' | 'rectangle';
};

export const BannerImage = ({ image, disabled, handleSelectedImage, imageVariant = 'rectangle' }: Props) => {
  const invalidPictureIdFromDB = '00000000-0000-0000-0000-000000000000'; // fix for the TM learning materials added in the past

  const [imgHeight, setImgHeight] = useState<number>(0);
  const [imgWidth, setImgWidth] = useState<number>(0);
  const [isFileManagerModalOn, setIsFileManagerModalOn] = useState<boolean>(false);

  const openFileManagerModal = () => {
    setIsFileManagerModalOn(true);
  };

  const onClose = (media: FileNode | undefined) => {
    if (media) {
      handleSelectedImage(media.id);

      calculateImageDimensions(media.url);
    }
    setIsFileManagerModalOn(false);
  };

  const calculateImageDimensions = (url: string) => {
    let img = new Image();
    img.src = url;
    img.onload = () => {
      setImgHeight(img.height);
      setImgWidth(img.width);
    };
  };

  useEffect(() => {
    if (image) {
      calculateImageDimensions(image?.fileUrl);
    }
  }, [image]);

  return (
    <div>
      <div className='banner-image-wrapper'>
        <div>
          {image && image.id !== invalidPictureIdFromDB ? (
            <img className={`preview preview--${imageVariant}`} src={image?.fileUrl ?? ''} alt={image?.originalFilename ?? ''} />
          ) : (
            <div className={`preview preview--${imageVariant} preview__empty`}></div>
          )}
          <div className='img-description'>
            {!image ? (
              <span>Choose an image*</span>
            ) : (
              <>
                <Subtitle>
                  <>{image?.originalFilename ?? ''}</>
                </Subtitle>
                <Paragraph>
                  <>
                    {imgWidth} x {imgHeight} px
                  </>
                </Paragraph>
              </>
            )}
          </div>
        </div>
        <EditFileButton isAdd={!image} disabled={disabled} onClick={openFileManagerModal} />
        {isFileManagerModalOn ? <FileManagerModal open={isFileManagerModalOn} onClose={onClose} /> : <></>}
      </div>
      <Paragraph className='disclaimer'>
        <>This image will be displayed at a maximum size of 2400 x 1600 px</>
      </Paragraph>
    </div>
  );
};
